<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="720" [(nzVisible)]="isVisible"
  [nzTitle]="data ? 'Edit Project' : 'Create New Project'" [nzFooter]="footerTpl" (nzOnClose)="closeonly()"
  [nzSize]="'default'">
  <form [formGroup]="projectForm" nz-form nzLayout="horizontal" *nzDrawerContent>
    <!-- Client Name -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Client Name</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select a client">
        <nz-select nzShowSearch nzServerSearch nzAllowClear [nzDisabled]="disabledClient"
          [nzFilterOption]="nzFilterOption" (nzOnSearch)="search($event)" formControlName="project_client"
          nzPlaceHolder="Select client">

          @if (!loadingClient) {
          @for(client of listOfClient; track client.id) {
          <nz-option [nzValue]="client.id" [nzLabel]="client.name"></nz-option>
          }
          } @else {
          <nz-option nzDisabled nzCustomContent>
            <nz-icon nzType="loading" class="loading-icon" />
            Loading Data...
          </nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Project Name -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Project Name</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please enter project name">
        <input nz-input formControlName="name" placeholder="Add project name" />
      </nz-form-control>
    </nz-form-item>

    <!-- Project Description -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Description</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please enter project description">
        <quill-editor theme="snow" placeholder="Enter full task description" class="content-editor"
          [modules]="quillConfig" formControlName="description"></quill-editor>
      </nz-form-control>
    </nz-form-item>

    <!-- Contract Value -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Contract Value</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please enter Contract Value">
        <nz-input-group nzAddOnBefore="$USD">
          <input type="number" nz-input formControlName="project_cost" />
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>

    <!-- Total Events -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Total Events</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please enter total events">
        <input type="number" min="0" nz-input formControlName="total_events" placeholder="Enter total events" />
      </nz-form-control>
    </nz-form-item>

    <!-- Due Date -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Due Date</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select due date">
        <nz-date-picker formControlName="due_date" [nzFormat]="'yyyy-MM-dd'" class="w-100"
          nzPlaceHolder="Select due date"></nz-date-picker>
      </nz-form-control>
    </nz-form-item>

    <!-- Global/Regional -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Coverage</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select coverage type">
        <nz-radio-group formControlName="is_global_region">
          <label nz-radio [nzValue]="false">Regional</label>
          <label nz-radio [nzValue]="true">Global</label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>

    <!-- Regions -->
    <nz-form-item *ngIf="projectForm.get('is_global_region')?.value === false">
      <nz-form-label [nzSpan]="7" nzRequired>Regions</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select regions">
        <nz-select nzShowSearch nzAllowClear nzServerSearch (nzOnSearch)="onSearchRegion($event)"
          nzMode="multiple" [nzMaxTagCount]="10" formControlName="regions" nzPlaceHolder="Select regions">
          @for (region of regionList; track region.id) {
          <nz-option [nzValue]="region.id" [nzLabel]="region.name"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Location -->
    <!-- <nz-form-item>
      <nz-form-label [nzSpan]="7">Location</nz-form-label>
      <nz-form-control [nzSpan]="17">
        <nz-select nzShowSearch nzAllowClear formControlName="city" nzServerSearch (nzOnSearch)="onSearchCity($event)"
          (ngModelChange)="onCitySelect($event)" nzPlaceHolder="Search and select location">
          @for (city of cityList; track city.id) {
          <nz-option [nzValue]="city.id"
            [nzLabel]="`${city.name}, ${city.state_name}, ${city.country_name}`"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item> -->



    <!-- Contract Type -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Contract Type</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select contract type">
        <nz-select formControlName="contact_type" nzPlaceHolder="Select contact type">
          @for(contactType of contactTypeList; track contactType.id) {
          <nz-option [nzValue]="contactType.id" [nzLabel]="contactType.name"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Sign-up Date -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Sign-up Date</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select sign-up date">
        <nz-date-picker formControlName="signup_date" [nzFormat]="'yyyy-MM-dd'" class="w-100"
          nzPlaceHolder="Select sign-up date"></nz-date-picker>
      </nz-form-control>
    </nz-form-item>

    <!-- Make good completed -->
    <nz-form-item *ngIf="projectForm.get('contact_type').value === 2">
      <nz-form-label [nzSpan]="7">Previous Project</nz-form-label>
      <nz-form-control [nzSpan]="17">
        <nz-select nzShowSearch nzServerSearch formControlName="previous_project" [nzAllowClear]="true"
          (nzOnSearch)="searchProject($event)" nzPlaceHolder="Select Previous Project">
          <nz-option *ngFor="let project of projectList" [nzValue]="project.id" [nzLabel]="project.name"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Project Format -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Project Format</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select project format">
        <nz-radio-group formControlName="project_format">
          @for(format of projectFormatList; track format.id) {
          <label nz-radio [nzValue]="format.id">{{ format.name }}</label>
          }
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>

    <!-- Project Type -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Project Type</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select project type">
        <nz-select formControlName="project_format_type" [nzAllowClear]="true" nzPlaceHolder="Select project type">
          @for(type of projectFormatTypeList; track type.id) {
          <nz-option [nzValue]="type.id" [nzLabel]="type.name"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>


    <!-- Assigned To Group -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Assigned To Group</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select a group">
        <nz-select nzShowSearch nzMode="multiple" [nzMaxTagCount]="10" [nzAllowClear]="true"
          formControlName="assigned_to_group" nzPlaceHolder="Select a group">
          @for(user of listOfUserGroup; track user.id) {
          <nz-option [nzValue]="user.id" [nzLabel]="user.name"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>


    <!-- Assign To -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7">Assign To</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select a person">
        <nz-select nzShowSearch nzServerSearch (nzOnSearch)="onSearchMember($event)"
          (nzOpenChange)="onAssignToDropdownChange($event)" nzMode="multiple" [nzMaxTagCount]="10" [nzAllowClear]="true"
          formControlName="assign_to" nzPlaceHolder="Select a person">
          @for(user of listOfUser; track user.id) {
          <nz-option [nzValue]="user.id" [nzLabel]="`${user.name}`"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>



    <!-- Customer Success Manager (CSM) -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7">CSM</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select a CSM">
        <nz-select nzShowSearch nzServerSearch (nzOnSearch)="onSearchCSM($event)"
          formControlName="customer_success_manager" [nzAllowClear]="true" nzPlaceHolder="Select a CSM">
          @for(user of listOfCsmUser; track user.id) {
          <nz-option [nzValue]="user.id" [nzLabel]="user.name"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Status -->
    <nz-form-item *ngIf="data != null">
      <nz-form-label [nzSpan]="7">Status</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select status">
        <nz-select formControlName="status" nzPlaceHolder="Select Status">
          <nz-option *ngFor="let status of projectStatusList" [nzValue]="status.id" [nzLabel]="status.name"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- closed_reason -->
    <nz-form-item *ngIf="projectForm.get('status').value === 4">
      <nz-form-label [nzSpan]="7">Closed Reason</nz-form-label>
      <nz-form-control [nzSpan]="17">
        <nz-select formControlName="closed_reason" nzPlaceHolder="Select Reason">
          <nz-option *ngFor="let reason of closedCancelledReason" [nzValue]="reason.id"
            [nzLabel]="reason.name"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>



    <!-- closed_reason -->
    <nz-form-item *ngIf="projectForm.get('status').value === 6">
      <nz-form-label [nzSpan]="7">Cancelled Reason</nz-form-label>
      <nz-form-control [nzSpan]="17">
        <nz-select formControlName="cancelled_reason" nzPlaceHolder="Select Reason">
          <nz-option *ngFor="let reason of closedCancelledReason" [nzValue]="reason.id"
            [nzLabel]="reason.name"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- cancelled_closed_reason_str -->
    <nz-form-item *ngIf="projectForm.get('status').value === 6 || projectForm.get('status').value === 4">
      <nz-form-label [nzSpan]="7">Cancelled closed reason</nz-form-label>
      <nz-form-control [nzSpan]="17">
        <input type="text" nz-input formControlName="cancelled_closed_reason_str" />
      </nz-form-control>
    </nz-form-item>


    <!-- Upload Contract -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7">Upload Contract</nz-form-label>
      <nz-form-control class="fileUpload" [nzSpan]="17">
        <nz-upload [nzSize]="5120" [nzCustomRequest]="customUploadRequest" nzListType="picture"
          [nzBeforeUpload]="beforeUpload" (nzChange)="onUploadContractChange($event)" [(nzFileList)]="scfileList">
          <button nz-button>
            <i nz-icon nzType="paper-clip"></i> Attach Files
          </button>
        </nz-upload>
        <p style="font-size:10px;font-weight: 500;font-style: italic;color:grey;
          position:absolute;right:10px;top:6px"> Accepted formats: .pdf, .jpeg, .jpg etc. (Add max file size 5 MB)</p>
      </nz-form-control>
    </nz-form-item>

    <!-- Additional Files -->
    <nz-form-item>
      <nz-form-label [nzSpan]="7">Additional Files</nz-form-label>
      <nz-form-control [nzSpan]="17" class="fileUpload">
        <nz-upload [nzSize]="5242880" [nzCustomRequest]="customUploadRequest" nzListType="picture"
          [nzBeforeUpload]="beforeUpload" (nzChange)="onUploadAdditionalChange($event)" [(nzFileList)]="fileList">
          <button nz-button>
            <i nz-icon nzType="paper-clip"></i> Attach Files
          </button>
        </nz-upload>
        <p style="font-size:10px;font-weight: 500;font-style: italic;color:grey;
          position:absolute;right:10px;top:6px"> Accepted formats: .pdf, .jpeg, .jpg etc. (Add max file size 5 MB)</p>
      </nz-form-control>
    </nz-form-item>

    <!-- Address Section -->
    <!-- <fieldset>
      <legend>Links</legend>
      <nz-row [nzGutter]="16">
        <nz-col *ngFor="let link of projectLinks; let i = index; e" [nzSpan]="12">
          <div class="poc-wrapper" >
            
            <nz-icon nzType="link" nzTheme="outline"   style="flex: 0 0 32px; margin-right: 16px;font-size:22px"/>
            <div style="flex: 1;">
              <div class="poc-name"style="color: #555;">Name : {{ link?.name  }}</div>
              <div class="poc-phone" style="color: #555;">Url : {{ link?.url  }}</div>
              <div class="poc-phone" style="color: #555;">Type : {{ link?.type  }} </div>
            </div>
           
           <span style="cursor: pointer;"  (click)="deletelink(link)">  <nz-icon nzType="delete" nzTheme="fill"  /></span>
      
          </div>
        </nz-col>

        <nz-col [nzSpan]="12">
          <div class="poc-wrapper add-poc" (click)="openAddLink()">
            <nz-avatar nzIcon="plus" [nzSize]="64" style="flex: 0 0 64px; cursor: pointer; margin-top: 8px;"></nz-avatar>
            <div class="info">
              <div class="name">Add New link</div>
              <p><span nz-typography nzType="secondary">Click to add new link</span></p>
            </div>
          </div>
        </nz-col>
      </nz-row>
    </fieldset> -->
  </form>
</nz-drawer>

<ng-template #footerTpl>
  <div style="float: right">
    <button nz-button style="margin-right: 8px;" (click)="closeonly()">Cancel</button>
    <button nz-button nzType="primary" (click)="onSubmit()"> {{data ? 'Update' : 'Create'}} </button>
  </div>
</ng-template>